"use client";

import dynamic from "next/dynamic";
import { getEnv } from "@/env";
import { resolveDynamicExperienceEnvironment } from "./environment";

const DynamicExperienceWrapper = dynamic(() => import("./index"), {
  ssr: false,
});

type ShortCodeDynamicExperienceEmbedProps = {
  flow_id?: string;
};

const flowIdFromAttribute = (flowId: string | undefined) =>
  flowId?.trim() ?? "";

/**
 * Mounts a published UCL Dynamic Experience by flow id.
 * [dynamic-experience-embed flow_id="example-flow" /]
 */
export const ShortCodeDynamicExperienceEmbed = ({
  flow_id,
}: ShortCodeDynamicExperienceEmbedProps) => {
  const flowId = flowIdFromAttribute(flow_id);
  if (!flowId) return null;

  return (
    <DynamicExperienceWrapper
      forcedFlowId={flowId}
      environment={resolveDynamicExperienceEnvironment()}
      tagularSourceKey={getEnv("NEXT_PUBLIC_AUTHX_TENANT_ID") || ""}
    />
  );
};
